import { observer } from "mobx-react-lite"

import type { ClFarmStore } from "@/domains/cl-farm/cl-farm-store"
import type { ILiquidityPool } from "@/domains/pools/types"
import { TokenStore } from "@/domains/tokens"

import { FarmingRewardsView } from "./farming-rewards-view"
import { NoClFarmRewards } from "./no-cl-farm-rewards"

export type ClFarmRewardsViewProps = {
  governanceToken: TokenStore
  farms: Array<ClFarmStore>
  onClaimAllClFarmRewards: (farms: Array<ClFarmStore>) => void
  onClaimClFarmReward: (farm: ClFarmStore) => void
}

export const ClFarmRewardsView = observer(
  ({ governanceToken, farms, onClaimAllClFarmRewards, onClaimClFarmReward }: ClFarmRewardsViewProps) => {
    const handleClaimAll = (pools: Array<ILiquidityPool>) => {
      onClaimAllClFarmRewards(pools as Array<ClFarmStore>)
    }

    const handleClaim = (pool: ILiquidityPool) => {
      onClaimClFarmReward(pool as ClFarmStore)
    }

    return (
      <FarmingRewardsView
        title="CL Farms"
        description="Rewards earned by staking liquidity positions into Scale CL Farms."
        poolType="CL"
        governanceToken={governanceToken}
        pools={farms}
        onClaimAllLpRewards={handleClaimAll}
        onClaimLpReward={handleClaim}
        emptyState={<NoClFarmRewards />}
      />
    )
  },
)
